//ANIMATION CODE STARTS
const pageVariants = {
    initial :{
        opacity: 0.8,
        scale: 1
    },
    in:{
        opacity: 1,
        scale:1
    },
    out:{
        opacity: 0,
        scale: 0.9
    }
  };
  
  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.8
  };
  
  const pageStyle = {
    position: "absolute"
  }
  
  //ANIMATION CODE ENDS

  export { pageTransition, pageStyle, pageVariants };